import React from 'react';
import formFieldType from '@/forms/helper';
import FormObjectDialog from '@/forms/objects/components/FormObjectDialog';
import requestFieldComponents from '../helper';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const RequestObjectDialog = ({ theme }) => {
  const state = selectors.useRequestObjectFields();
  const applyChanges = events.useApplyRequestObjects(state.category, { code: state.code });
  const changeItem = events.useUpdateActiveRequestObject();
  const deleteItem = events.useDeleteActiveRequestObject();
  const hide = events.useHideRequestObjects();
  const insertItem = events.useInsertRequestObject();
  const updateProperties = events.useUpdateRequestObjectProperties();
  const updateObjectsProperties = events.useUpdateRequestObjectsProperties();

  return (
    <FormObjectDialog
      activeIndex={state.activeIndex}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit={state.canEdit}
      category={state.category}
      changeItem={changeItem}
      code={state.code}
      component={(f) => requestFieldComponents[formFieldType(f)]}
      deleteItem={deleteItem}
      entity="request.object"
      field={state.field}
      fields={state.field?.fields || []}
      hide={hide}
      insertItem={() => insertItem(state)}
      isDirty={state.isDirty}
      isEditing={state.isEditing}
      item={state.item}
      items={state.items}
      onSave={() => applyChanges(state)}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
      textField={state.textField}
      theme={theme}
      updateObjectsProperties={updateObjectsProperties}
      updateProperties={updateProperties}
    />
  );
};

export default RequestObjectDialog;
